//used in auth login modal and register modal
const AskToggle = ({ setAuth, fromRegister = false, t }) => {
  return (
    <div className='col-span-full mb-2 flex items-center justify-center gap-2 text-center lg:mb-4'>
      <span className='font-medium max-lg:text-sm'>
        {!fromRegister
          ? t('Dont have An Account ?')
          : t('Already have an account?')}
      </span>
      <button
        type='button'
        onClick={() => setAuth(!fromRegister ? 'register' : 'login-mobile')}
        className='cursor-pointer font-bold underline max-lg:text-sm'
      >
        {!fromRegister ? t('Register') : t('Login')}
      </button>
    </div>
  );
};

export default AskToggle;
